export default {
  newKeyword: {
    id: 'card_new_keyword',
    defaultMessage: 'new',
  },
} as const
